import { ColorOptions, convertHexToRGBA, Image, ModBox, useWindowDimensions } from '@jfs/ui-new'
import { Colors } from '../../../util/util'

const CarousalItem = ({ onPressBanner, data }) => {
  const width = useWindowDimensions()
  return (
    <ModBox
      bg={convertHexToRGBA(Colors.PRIMARY, 8) as ColorOptions}
      borderRadius={16}
      w={width - 48}
      marginRight={24}
      ml={24}
      overflow={'hidden'}
      onPress={() => onPressBanner(data)}
      testID={'banner-item'}
      underlayColor="TRANSPARENT"
      align="center"
      justify="center">
      <Image resizeMode="stretch" source={data?.imageName} width={'100%'} height={147} />
    </ModBox>
  )
}

export default CarousalItem
